<app-daily-agenda-wrapper
  [timezone]="timezone"
  [activeDay]="activeDay"
  [activeEvent]="activeEvent"
  [selectedDate]="selectedDate"
></app-daily-agenda-wrapper>
